import React, { useState, useEffect } from "react";
import PropTypes, { element } from "prop-types";
import InvoiceLineItemShow from "./InvoiceLineItemShow";
import { HTTP } from "../../api/resources";
import PaymentDateModal from '../Helpers/Modal/PaymentDateModal'
import PaymentTypeModal from "../Helpers/Modal/PaymentTypeModal";

export default function InvoicesShow(props) {
  const [invoice, setInvoice] = useState(props.invoice);
  const [lineItems, setLineItems] = useState(props.line_items);
  const [orgName, setOrgName] = useState(props.team.name);
  const [logoUrl, setLogoUrl] = useState(props.team.logo_url);
  const [openPaymentsModal, setOpenPaymentModal] = useState(false)
  const [savingPayments, setSavingPayments] = useState(false)
  const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)
  const [markable, setMarkable] = useState(false)
  const [saving, setSaving] = useState(false)
  const [amountWithFee, setAmountWithFee] = useState(0)
  const [remainingBalance, setRemainingBalance] = useState(0)
  let donation;
  let donationLineItems = [];
  let totalInvoiceAmount = 0;
  let user = props.user
  let url = `https://giveclarity.co/payment_method/${invoice.user_id}/${invoice.id}`
  let authorized_user = user.id == invoice.user_id || user.user_type == "manager" || user.user_type == "assistant_manager"
  for (const [index, lineItem] of lineItems.entries()) {
    // donation = props.donations.find(element => element.id == lineItem.donation_id);
    totalInvoiceAmount = totalInvoiceAmount + +lineItem.total_line_item;
  }

  useEffect(() => {
    if (invoice.status == 'paid') {
      invoice.payments.map(payment => {
        if (payment.method.includes('Stripe')) {
          setMarkable(true)
          return
        }
      })
    }

    if (invoice.archived == true) {
      setMarkable(true)
    }
  }, [])

  for (const [index, lineItem] of lineItems.entries()) {
    let _id = lineItem.id || lineItem.new;
    lineItem._id = _id;

    donationLineItems.push(
      <InvoiceLineItemShow
        key={_id}
        lineItem={lineItem}
        donations={props.donations}
      />
    );
  }

  const checkPaymentStatus = () => {
    if (invoice.payments.length > 0) {
      if (window.confirm('This will remove payment date and payment type record from invoice')) {
        deleteInvoicePayment()
      }
      return
    } else {
      setOpenPaymentModal(true)
      return
    }
  }

  const deleteInvoicePayment = async () => {
    let data = {
      request_type: 'delete'
    }

    let response = null
    try {
      response = await updatePaymentInfo(data)
    } catch {
      Alert.show('error', 'Could not update, try again')
      return
    }

    Alert.show('notice', 'Deleted payment date and type record')
    setInvoice(response.data)
    setOpenPaymentModal(false)
  }

  useEffect(() => {}, [invoice])

  const handleAddDate = async (date, selectedPaymentType, amount) => {
    if (!date || date.length < 1) {
      Alert.show('notice', 'Payment date is required to save record')
      return
    }

    if (!selectedPaymentType) {
      Alert.show('notice', 'Payment method is required to save record')
      return
    }

    if (!amount || amount < 1) {
      Alert.show('notice', 'Payment amount is required to save record')
      return
    }

    setSavingPayments(true)

    let data = {
      request_type: 'update',
      payment_info: {
        payment_type: selectedPaymentType.method,
        payment_date: date,
        payment_amount: amount
      }
    }

    let response = null

    try {
      response = await updatePaymentInfo(data)
    } catch {
      Alert.show('error', 'Could not save record, try again')
      setSavingPayments(false)
      return
    }

    Alert.show('notice', 'Saved record successfully')
    setInvoice(response.data)
    setOpenPaymentModal(false)
    setSavingPayments(false)
  }

  const updatePaymentInfo = (data) => {
    return HTTP.patch(`/invoice/paymentinfo/${invoice.id}/${invoice.user_id}`, data)
  }

  // subscribe to invoice
  const subscribe = () => {
    // subscription logic
    setOpenSubscriptionModal(false)
  }

  const NotifyUser = async () => {
    setSaving(true)

    try {
      await notificationRequest()
    } catch {
      Alert.show('error', 'Could not send notification')
      setSaving(false)
      return
    }

    Alert.show('notice', 'Notification was sent successfully')
    setSaving(false)
  }

  const notificationRequest = () => {
    return HTTP.post(`/invoice/notification/${invoice.id}`)
  }

  useEffect(() => {
    if (invoice.isRecurring) {
      let amount = totalInvoiceAmount * 0.034 + 0.30
      setAmountWithFee(totalInvoiceAmount + amount)
      setRemainingBalance(amountWithFee - invoice.paid_amount)
      if (invoice.status == 'paid') setRemainingBalance(0.00)
    }

    if (!invoice.isRecurring) {
      let amount = totalInvoiceAmount * 0.029 + 0.30
      setAmountWithFee(totalInvoiceAmount + amount)
      setRemainingBalance(amountWithFee - invoice.paid_amount)
      if (invoice.status == 'paid') setRemainingBalance(0.00)
    }
  }, [invoice])

  const getData = (item) => {
    let donate = props.donations.find(element => element.id == item.donation_id);
    const totalDonation = +donate.unit_cost * +item.quantity;
    const totalTax = +item.tax;
    const totalLineItem = totalDonation + totalTax;

    return {donation: donate, cost: totalLineItem}
  }


  return (
    <React.Fragment>
      {!props.public &&
        <div className="page-header d-flex align-items-baseline">
          <h4 className="">
            <a href={`/d/${invoice.user_id}/invoices`}>
              <i className="fa fa-chevron-left mr-2"></i> Back
            </a>
          </h4>
          <ul className="breadcrumbs">
            <li className="nav-item">Invoices</li>
            <li className="separator">
              <i className="fa fa-arrow-right"></i>
            </li>
            <li className="nav-item">{invoice.invoice_number}</li>
          </ul>
          <div className="page-actions show-mobile">
          <div className="btn-group align-center">

        {invoice.status !== 'paid' && !invoice.auto_pay &&
          <button className="btn btn-primary btn-sm ml-3" onClick={NotifyUser} disabled={saving}>
            {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
            Notify User
          </button>
        }

          {invoice.payments.length < 1 && invoice.isChild && (user.user_type == 'manager' || user.user_type == 'assistant_manager') && !markable && (
            <button
              className="btn btn-secondary btn-sm ml-3"
              onClick={() => checkPaymentStatus()}
            >
              Mark Paid
            </button>
          )}
          {invoice.payments.length > 0 && invoice.isChild &&  (user.user_type == 'manager' || user.user_type == 'assistant_manager') && !markable && (
            <>
            <button
              className="btn btn-secondary btn-sm ml-3"
              onClick={() => checkPaymentStatus()}
            >
              Mark Active
            </button>

            {invoice.paid_amount > 0 && invoice.paid_amount < totalInvoiceAmount && !markable &&
            <button
              className="btn btn-primary btn-sm ml-3"
              onClick={() => setOpenPaymentModal(true)}
            >
              + Add Payment
            </button>
            }
            </>
          )}
          </div>
          </div>
        </div>}
        {props.public && invoice.status !== 'paid' && !invoice.auto_pay &&
        <div className="page-header d-flex align-items-baseline">
        <div className="page-actions show-mobile">
        <div className="btn-group align-center">
            <button
              className="btn btn-primary ml-3"
              onClick={() => {
                if (!invoice.offer_auto_pay || !invoice.isRecurring || props.todaysDate >= invoice.invoice_date) {
                  window.location = invoice.payment_link_url
                } else {
                  setOpenSubscriptionModal(true)
                }
              }}
            >
              Pay Now
            </button>
        </div>
        </div>
      </div>
      }
      <div className="card">
        <div className="card-body">
          <div className="row f-row-in">
            <div className="col-md-5">
              <div className="in-logo-container">
                {logoUrl && (
                  <img src={logoUrl} alt={orgName} className="logo-invoice" />
                )}
                {!logoUrl && (
                  <img
                    src="http://giveclarity.co/logo.png"
                    alt="Clarity"
                    className="logo-invoice"
                  />
                )}
              </div>
              <h4>{orgName}</h4>
            </div>

            <div className="col-md-4">
              <h1 className="invoice-he-ti">INVOICE</h1>
            </div>
            <div className="col-md-3">
              <div className="invoice-status">
                <strong>Status</strong>
                <div>
                  {invoice.status
                    ? invoice.status.charAt(0).toUpperCase() +
                      invoice.status.slice(1)
                    : "Draft"}
                </div>
              </div>

              {invoice.status == "paid" && invoice.payment_date&& (
                <div className="mt-1" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <label htmlFor="payment me-2"><strong>Payment date:</strong> {invoice.payment_date}</label>
                </div>
              )}
            </div>
          </div>

          <div className="row s-row-in">
            <div className="col-md-5 col-in-f">
              <h4>Invoice To: </h4>
              <h5>
                Donor: {props.donor.last_name}, {props.donor.first_name}
              </h5>

                {!props.public &&
                <>
                  <div>{props.custom_field.address}</div>
                  <div>{props.custom_field.city}</div>
                  <div>{props.custom_field.state}</div>
                  <div>{props.custom_field.code}</div>
                  <div>{props.custom_field.country}</div>
                  </>
                }
            </div>
            <div className="col-md-7">
              <div className="form-group rd-pad-in">
                <label htmlFor="invoice_number">
                  Invoice Number: {invoice.invoice_number}
                </label>
              </div>
              <div className="form-group rd-pad-in">
                <label htmlFor="invoice_date">
                  Invoice Date: {invoice.invoice_date}
                </label>
              </div>
              <div className="form-group rd-pad-in">
                <label htmlFor="due_date">Due Date: {invoice.due_date}</label>
              </div>
            </div>
          </div>

          <div className="table-container">
            <table className="in-show-tb mt-3">
              <tr style={{width: '100%'}}>
                <th className="t-header-one" style={{ width: '45%' }}>Donation</th>
                <th className="t-header-tw" style={{ width: '20%' }}>Receiver</th>
                <th className="t-header-tw" style={{ width: '10%' }}>Quantity</th>
                <th className="t-header-tw" style={{ width: '10%' }}>Tax</th>
                <th className="t-header-tw" style={{ width: '15%' }}>Total</th>
              </tr>
              {lineItems && lineItems.map(item => (
                <tr style={{overflow: 'auto'}} key={item.id}>
                  <td className="t-header-one" style={{ width: '45%', minWidth: '50ch' }}>
                    {getData(item).donation.name} | {getData(item).donation.description} | ${parseFloat(getData(item).donation.unit_cost).toFixed(2)} {getData(item).donation.currency}
                  </td>
                  <td className="t-header-tw" style={{ width: '20%' }}>{item.beneficiary.name}</td>
                  <td className="t-header-tw" style={{ width: '10%' }}>{item.quantity}</td>
                  <td className="t-header-tw" style={{ width: '10%' }}>{item.tax}</td>
                  <td className="t-header-tw" style={{ width: '15%' }}><strong>${parseFloat(getData(item).cost).toFixed(2)} {getData(item).donation.currency}</strong></td>
                </tr>
              ))}
            </table>
          </div>

          <div className="row">
            <div className="col-md-9"></div>
            <div className="col-md-3">
              <div className="form-group">
                <div style={{ textAlign: "center" }}>
                  <strong>Total Invoice Amount</strong>
                </div>
                <div style={{ textAlign: "center" }}>
                  {(!invoice.use_stripe || !invoice.pass_processing_fee) &&
                    <strong>${parseFloat(totalInvoiceAmount).toFixed(2)} USD</strong>
                  }

                  {invoice.use_stripe && invoice.pass_processing_fee &&
                    <strong>${parseFloat(amountWithFee).toFixed(2)} USD</strong>
                  }
                </div>
              </div>
            </div>
          </div>

          {invoice.payments.length > 0 &&
            <div className="row">
            <div className="col-md-5"></div>
            <div className="col-md-7">
                <div>
                  <table className="in-show-tb mt-3">
                    <tr>
                      <th className="t-header-one">Payment Date</th>
                      <th className="t-header-tw">Amount</th>
                      <th className="t-header-tw">Method</th>
                    </tr>
                    {invoice.payments.map(payment => (
                    <tr>
                      <td className="t-header-one">{payment.date}</td>
                      <td className="t-header-tw">${payment.amount}</td>
                      <td className="t-header-tw">{payment.method}</td>
                    </tr>
                    ))}
                  </table>
                </div>
              </div>
          </div>
          }

          {invoice.paid_amount > 0 &&
          <div className="row">
            <div className="col-md-9"></div>
            <div className="col-md-3">
              <div className="form-group">
                <div style={{ textAlign: "center" }}>
                  <strong>Remaining Balance</strong>
                </div>
                <div style={{ textAlign: "center" }}>
                  {(!invoice.use_stripe || !invoice.pass_processing_fee) && invoice.status !== 'paid' &&
                    <strong>${(totalInvoiceAmount - invoice.paid_amount).toFixed(2)} USD</strong>
                  }

                  {(!invoice.use_stripe || !invoice.pass_processing_fee) && invoice.status == 'paid' &&
                    <strong>$0.00 USD</strong>
                  }

                  {invoice.use_stripe && invoice.pass_processing_fee &&
                    <strong>${remainingBalance.toFixed(2)} USD</strong>
                  }
                </div>
              </div>
            </div>
          </div>
          }
         </div>

          <div className="in-show-footer">
            <div className="row">
              <div className="col-md-5">
              </div>
              <div className="col-md-7">
              <div className="in-sh-footer-it w-100">
              <div>
                <strong>Notes</strong>
              </div>
              <div
                className="in-sh-footer-de"
                contenteditable="false"
                data-placeholder="No notes at the moment..."
              >
                {invoice.notes}
              </div>
            </div>
            <div className="in-sh-footer-it w-100">
              <div>
                <strong>Terms</strong>
              </div>
              <div
                className="in-sh-footer-de"
                contenteditable="false"
                data-placeholder="No terms at the moment..."
              >
                {invoice.terms}
              </div>
            </div>
            {(invoice.status == "active" || invoice.status == "sent") && invoice.payment_link_url && !invoice.auto_pay && !props.public &&
              authorized_user && invoice.use_stripe &&
              <div className="in-sh-footer-it w-100">
                <div><strong>Payment Link</strong></div>
                  <div className="in-sh-footer-de" contenteditable="false" data-placeholder="No payment link at the moment...">
                      <a href={`https://giveclarity.co/pub/inv/${invoice.user_id}/${invoice.id}`} target="_blank" className="click_link_pay">
                        {`https://giveclarity.co/pub/inv/${invoice.user_id}/${invoice.id}`}
                      </a>
                  </div>
              </div>
              }
          </div>
         </div>

        </div>
      </div>

      {/* modals */}
      {openPaymentsModal &&
        <PaymentDateModal handleClose={() => setOpenPaymentModal(false)} saving={savingPayments}
          handleAddDate={(date, selectedPaymentType, amount) => handleAddDate(date, selectedPaymentType, amount)}
          balance={totalInvoiceAmount - invoice.paid_amount}
        />
      }

      {openSubscriptionModal &&
        <PaymentTypeModal paymentLink={invoice.payment_link} autopay={subscribe} invoice={invoice}/>
      }
    </React.Fragment>
  );
}

InvoicesShow.propTypes = {
  invoice: PropTypes.object,
};
